import { schema } from 'normalizr';
import { userSchema } from 'Root/modules/users/schema';

export const toDoSchema = new schema.Entity('toDos', {
  suggestor: userSchema,
});
